export const PLAYBOOK_ACTIVE_TAB_INDEX = "PLAYBOOK_ACTIVE_TAB_INDEX"